@if (alerts()?.length > 0) {
  <div class="flex">
    @for (alert of alerts(); track $index; let i = $index) {
      <fuse-alert
        [style]="{
          position: 'fixed',
          top: (20 + (i * 80)) + 'px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 9999,
          width: '90%',
          maxWidth: '500px'
        }"
        class="mt-6"
        [appearance]="'outline'"
        [showIcon]="false"
        [name]="alert.id"
        [type]="alert.type"
        [dismissible]="true"
        [@shake]="alert.type === 'error'"
      >
        {{ alert.message }}
      </fuse-alert>
    }
  </div>
}
<router-outlet></router-outlet>
